<script setup>
import { Toaster } from "vue-sonner";
import { FeatureIcon } from "@/Components/Dialog";
import { LoadingSpinner } from "@/Components";
import { directionStore } from "@/Stores/direction";
import { Icon } from "@/SharedComponents/Icon";

const useDirectionStore = directionStore();

const props = defineProps({
  invert: { type: Boolean, required: false },
  theme: { type: String, required: false },
  position: { type: String, required: false },
  hotkey: { type: Array, required: false },
  richColors: { type: Boolean, required: false },
  expand: { type: Boolean, required: false },
  duration: { type: Number, required: false },
  gap: { type: Number, required: false },
  visibleToasts: { type: Number, required: false },
  closeButton: { type: Boolean, required: false },
  toastOptions: { type: Object, required: false },
  class: { type: String, required: false },
  style: { type: null, required: false },
  offset: { type: [String, Number], required: false },
  icons: { type: Object, required: false },
  containerAriaLabel: { type: String, required: false },
  pauseWhenPageIsHidden: { type: Boolean, required: false },
  cn: { type: Function, required: false },
});
</script>

<template>
  <Toaster
    class="toaster group z-toast fixed pointer-events-auto"
    v-bind="props"
    :dir="useDirectionStore.getDirection"
    :toast-options="{
      classes: {
        toast: `group toast group-[.toaster]:items-start ltr:group-[.toaster]:pr-10 rtl:group-[.toaster]:pl-10 group-[.toaster]:gap-4 group-[.toaster]:bg-primary group-[.toaster]:text-foreground group-[.toaster]:border-none group-[.toaster]:shadow-3xl`,
        title:
          'group-[.toast]:text-secondary group-[.toast]:text-base group-[.toast]:font-semibold',
        description: 'group-[.toast]:text-tertiary group-[.toast]:text-sm',
        actionButton:
          'group-[.toast]:bg-primary group-[.toast]:text-primary_on-brand',
        cancelButton:
          'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
      },
    }"
  >
    <template #success-icon>
      <FeatureIcon class="p-2 bg-success-secondary">
        <Icon name="checkmark-default" size="xl" class="fg-success-primary" />
      </FeatureIcon>
    </template>
    <template #error-icon>
      <FeatureIcon class="p-2 bg-error-secondary">
        <Icon name="info-circle" size="xl" class="fg-error-primary" />
      </FeatureIcon>
    </template>
    <template #info-icon>
      <FeatureIcon class="p-2 bg-brand-secondary">
        <Icon name="info-circle" size="xl" class="text-brand-tertiary" />
      </FeatureIcon>
    </template>
    <template #loading-icon>
      <FeatureIcon class="p-2">
        <LoadingSpinner class="w-5 h-5 text-brand-tertiary" />
      </FeatureIcon>
    </template>
  </Toaster>
</template>
